<template>
  <!-- 创建积分优惠券 -->
  <div class="createPlayStep new-input-box">
    <div class="backBox">
      <jd-back
        @back="retrunMethod"
        :title="[
          activityData.singleCopy || isDraftEdit ? '活动管理' : '活动广场',
        ]"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>

    <div :class="{ formBox: localStep != 0 }">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <div class="firststep" v-if="localStep == 0">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg"
                      alt=""
                    />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    style="width: 100%; max-height: 380px"
                    :src="item.templateUrl"
                    alt=""
                  />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="secondstep" v-if="localStep == 1" v-loading="loading">
        <el-form :model="form" ref="form" label-width="130px">
          <el-form-item label="礼品名称:" required>
            <el-input
              v-model="form.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请填入活动名称"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <!-- 活动对象 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="resetMemberFn"
            :defaultActMember.sync="form.ruleDTO.activityTargetType"
            :plusObject.sync="form.ruleDTO.plusObject" 
            :isCheckOpenCardTime.sync="form.ruleDTO.isCheckOpenCardTime" 
            :openCardStartTime.sync="form.ruleDTO.openCardStartTime" 
            :openCardEndTime.sync="form.ruleDTO.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            v-model="form.ruleDTO"
            :activityId="9"
            :localStepNum="16"
            :isEdit="false"
            :disabled="false"
            :needNonMember="true"
            :showOpenCardTip="true"
            :basicInformation="false"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <el-form-item label="礼品图片:" required>
            <div class="unload-content">
              <el-upload
                :class="[
                  'img-uploader',
                  fileList.length ? 'hide-upload-btn' : '',
                ]"
                action="/jd-hd-web/image/upload"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :file-list="fileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <span style="color: red; font-size: 14px"
              >建议尺寸：360*360像素，图片大小不能超过1.5MB，类型：JPG、PNG</span
            >
          </el-form-item>

          <el-form-item label="兑换次数限制:">
            <span>活动期间每人每天最多可兑换</span>
            <el-input
              v-model="form.exchangeDayTimes"
              placeholder="不限制"
              @input="form.exchangeDayTimes = getNumberData(1, $event, 0, 1)"
              @blur="handleLimit"
              style="width: 136px; margin: 0 5px"
            ></el-input>
            <span>次，累计每人最多可兑换</span>
            <el-input
              v-model="form.exchangeTimes"
              placeholder="不限制"
              @input="form.exchangeTimes = getNumberData(1, $event, 0, 1)"
              @blur="handleLimit"
              style="width: 136px; margin: 0 5px"
            ></el-input>
            <span>次</span>
            <div style="color: red; font-size: 14px; line-height: 22px">
              注意:
              每日兑换数量限制不可大于最多兑换限制数量，未填写数量则表示不限
            </div>
          </el-form-item>

          <!-- 积分兑换爱奇艺-->
          <el-form-item
            label="发放数量:"
            v-if="activityTypes.includes(tabActive)"
            required
          >
            <span>活动期间每日最多可兑换</span>
            <el-input
              v-model="form.exchangeNumPerDay"
              @input="form.exchangeNumPerDay = getNumberData(1, $event, 0, 1)"
              @blur="handleLimit1"
              style="width: 136px; margin: 0 5px"
              placeholder="请输入"
            ></el-input>
            <span>张，累计最多可兑换</span>
            <el-input
              v-model="form.quantityTotal"
              @input="form.quantityTotal = getNumberData(1, $event, 0, 1)"
              @blur="handleLimit1"
              style="width: 136px; margin: 0 5px"
              placeholder="请输入"
            ></el-input
            >张
          </el-form-item>
          <el-form-item :label="labelText" required>
            <el-select
              v-model="form.itemId"
              style="width: 320px; margin-right: 10px"
              v-if="tabActive == 58 || tabActive == 59"
              @change="handlePrizeChange($event, 1)"
            >
              <el-option
                v-for="item in prizeMemberList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="form.assetsId"
              style="width: 320px; margin-right: 10px"
              placeholder="请选择"
              @change="handlePrizeChange($event, 2)"
              v-else
            >
              <el-option
                v-for="item in giftCardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span>
              <jd-button type="blueText" @click="refresh">刷新</jd-button>
            </span>
            <jd-button
              type="blueText"
              style="margin-left: 10px"
              @click="toRecharge"
              >{{ jumpText }}</jd-button
            >
            <div class="tip-color" v-if="tabActive == 58 || tabActive == 59">
              注：发放总量不能大于账户剩余量，发放数到达总量后，兑换活动自动结束
            </div>
            <div v-if="(tabActive == 60 || tabActive == 61)&&form.assetsId">
              剩余 <span class="tip-color">{{ quantityBalance }}</span> 张
            </div>
          </el-form-item>

          <el-form-item
            label="发行总量:"
            required
            v-if="tabActive == 60 || tabActive == 61"
          >
            <el-input
              v-model="form.quantityTotal"
              @input="form.quantityTotal = getNumberData(1, $event, 0, 1)"
              style="width: 136px; margin-right: 5px"
              placeholder="请输入发行总量"
            ></el-input
            >次
          </el-form-item>

          <el-form-item label="上下架时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.startTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :clearable="false"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.endTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :clearable="false"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime">
              活动持续
              <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question" style="color: #ccc"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>

          <el-form-item label="兑换所需等级:" required>
            <div class="level-wrap">
              <el-checkbox-group v-model="memberLe" @change="checkListchange">
                <el-checkbox :label="memberLe">全部</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group
                v-model="level"
                v-for="(item, index) in memberLevelList"
                :key="index"
                @change="checkTheChange"
              >
                <el-checkbox
                  :label="item.value"
                  :disabled="memberLe == true"
                  v-if="item.label"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>

          <el-form-item label="兑换所需积分:" required>
            <div class="isLevelSet" style="width: 600px">
              <template v-if="!isLevelSet">
                <el-input
                  v-model.number="memberLevelPoints"
                  @input="
                    (memberLevelPoints = getNumberData(1, $event, 0, 1)),
                      upodata()
                  "
                  style="width: 136px"
                  placeholder="请输入"
                ></el-input>
                积分=1{{ pointText }}
              </template>
              <template v-else>
                <ul class="levelList">
                  <li
                    class="item"
                    v-for="item in selectLevelList"
                    :key="item.value"
                  >
                    {{ item.label }}
                    <el-input
                      v-model.number="item.point"
                      placeholder="请输入"
                      @input="item.point = getNumberData(1, $event, 0, 1)"
                      style="width: 80px"
                    ></el-input>
                    积分=1{{ pointText }}
                  </li>
                </ul>
              </template>
              <jd-button type="blue" @click="isLevel" style="margin-left: 8px">
                {{ isLevelSet == false ? "按会员等级设置" : "统一设置" }}
              </jd-button>
            </div>
          </el-form-item>

          <el-form-item label="规则说明:" required>
            <div>
              <el-input
                type="textarea"
                class="textarea"
                style="width: 704px"
                resize="none"
                :rows="6"
                v-model="form.ruleDescription"
              ></el-input>

              <div class="flexc-cen-x" style="margin-top: 8px">
                <jd-button type="blue" @click="generativerule"
                  >生成规则</jd-button
                >
                <jd-tip style="width: fit-content; margin-left: 8px"
                  >提示：点击按钮自动生成规则，也可以自已编辑信息，手机端规则处显示。</jd-tip
                >
              </div>
            </div>
          </el-form-item>
          <div class="pd20">
            <jd-title label="展示店铺"></jd-title>
          </div>
          <el-form-item label="小程序店铺信息：" label-width="150px">
              <el-radio-group v-model="customerPaperwork.shopNameType">
                  <el-radio :label="0">统一显示配置店铺</el-radio>
                  <el-radio :label="2">不显示店铺信息</el-radio>
              </el-radio-group>
          </el-form-item>
          <!-- 新增字段 -->
          <el-form-item label="是否重点活动:" required>
            <div class="flexc-cen-x mt10">
              <el-radio-group v-model="isKeyActivity">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>
                    大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                  </div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="活动投放位置:" required>
            <el-checkbox-group v-model="placementPosition">
              <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
              <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
              <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
              <el-checkbox label="SHOP">店铺</el-checkbox>
              <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
              <el-checkbox label="OTHER">其他渠道</el-checkbox>
              <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                </template>
                <i class="new-icon-box ml8"></i>
              </el-tooltip>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <jd-button style="margin-right: 8px" @click="retrunMethod"
        >返回上一页</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >存为草稿</jd-button
      >
      <jd-button type="blue" @click="setActivity" v-preventReClick>
        保存并完成设置
      </jd-button>
    </div>
  </div>
</template>

<script>
import informationForm from "@/views/interactiveMarketing/activity/components/informationForm.vue";
import inputForm from "@/components/jhk/inputForm";
import QRCode from "qrcodejs2";
import {
  uploadpic,
  createPointsExchangeGift,
  inquireActivity,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import {
  allAccount,
  getGiftCardPage,
} from "@/api/jhk/integralCenter/prizeCenter.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    stepNum: {
      type: Number,
      default: 0,
    },
    tabActive: {
      type: Number,
      default: 29,
    },
    valueRow: null,
    activityData: {},
    isStart: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    inputForm,
    informationForm,
  },
  computed: {
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.isCopy;
    },
    pointText() {
      const textType = {
        58: "爱奇艺",
        59: "京东plus",
        60: "礼品卡",
        61: "百度网盘",
      };
      return textType[this.tabActive] || "";
    },
    labelText() {
      const textType = {
        58: "爱奇艺会员面值:",
        59: "PLUS会员面值:",
        60: "选择礼品卡:",
        61: "选择百度网盘:",
      };
      return textType[this.tabActive] || "";
    },
    jumpText() {
      const textType = {
        58: "去充值",
        59: "去充值",
        60: "创建礼品卡",
        61: "创建百度网盘",
      };
      return textType[this.tabActive] || "";
    },
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
  },
  data() {
    return {
      customerPaperwork: {
        shopNameType: 0,
      },
      isKeyActivity: 0,
      placementPosition: [],
      giftList: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      localStep: this.stepNum,
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
          );
        },
      },
      fileList: [],
      memberLevelPoints: "",
      butActive: 1,
      // 表单值
      form: {
        logo: "",
        activityName: "",
        startTime: "",
        endTime: "",
        ruleDescription: "",
        quantityTotal: "",
        exchangeDayTimes: "",
        exchangeTimes: "",
        exchangeNumPerDay: "",
        itemId: "",
        assetsId: "",
        ruleDTO: {
          activityTargetType: '1',
          partner: ["-1"],
          allowLevel: "-1",
          plusObject: 0,
          crowdIds: "",
          firstOpenCardTimeType: 0,
          openCardBeforeDay: "",
          orderCompleteLimitCount: "",
          orderCompleteMaxCount: "",
          orderCompleteLimitPayment: "",
          orderCompleteMaxPayment: "",
          lastOrderCompleteTimeType: 0,
          lastOrderCompleteStartDay: "",
          lastOrderCompleteEndDay: "",
          lastOrderCompleteStartTime: "",
          lastOrderCompleteEndTime: "",
          isCheckOpenCardTime: "",
          openCardStartTime: "",
          openCardEndTime: "",
        },
      },
      level: [],
      memberLevelList: [],
      selectLevelList: [],
      startTime: null,
      endTime: null,
      isLevelSet: false,
      dialogFormVisible: false,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
      quantityBalance: 0,
      useFullLevel: [],
      isCopy: false,
      isDraft: false,
      plusCount: 0,
      aqyList: [
        {
          label: "月卡",
          value: "8",
          quantityBalance: 0,
        },
        {
          label: "季卡",
          value: "12",
          quantityBalance: 0,
        },
        {
          label: "半年卡",
          value: "13",
          quantityBalance: 0,
        },
        {
          label: "年卡",
          value: "14",
          quantityBalance: 0,
        },
      ],
      jdPlusList: [
        {
          label: "年卡",
          value: "7",
          quantityBalance: 0,
        },
      ],
      prizeMemberList: [],
      giftCardList: [],
      activityTypes: [58, 59],
      giftCardEndTime: "",
      loading: false,
      peopleSelected: [],
    };
  },
  mounted() {
    if (this.tabActive == 58) {
      this.fileList = [
        {
          url: "https://cdn-image.yucrm.cn/images/conversion/aqy-bg.png?v1.0",
          name: "爱奇艺",
        },
      ];
      this.form.logo =
        "https://cdn-image.yucrm.cn/images/conversion/aqy-bg.png?v1.0";
    } else if (this.tabActive == 59) {
      this.fileList = [
        {
          url: "https://cdn-image.yucrm.cn/images/conversion/plus-bg.png?v1.0",
          name: "京东plus",
        },
      ];
      this.form.logo =
        "https://cdn-image.yucrm.cn/images/conversion/plus-bg.png?v1.0";
    } else if (this.tabActive == 60) {
      this.fileList = [
        {
          url: "https://cdn-image.yucrm.cn/images/conversion/giftcarf-bg.png?v1.0",
          name: "礼品卡",
        },
      ];
      this.form.logo =
        "https://cdn-image.yucrm.cn/images/conversion/giftcarf-bg.png?v1.0";
    } else {
      this.fileList = [
        {
          url: "https://cdn-image.yucrm.cn/images/conversion/bdwp-bg.png",
          name: "百度网盘",
        },
      ];
      this.form.logo =
        "https://cdn-image.yucrm.cn/images/conversion/bdwp-bg.png";
    }
    this.init();
    this.getLevel();
  },
  methods: {
    resetMemberFn(val) {
      this.peopleSelected = [];
      this.form.ruleDTO.partner = ["-1"];
      this.form.ruleDTO.firstOpenCardTimeType = 0;
      this.form.ruleDTO.openCardBeforeDay = "";
      this.form.ruleDTO.orderCompleteLimitCount = "";
      this.form.ruleDTO.orderCompleteMaxCount = "";
      this.form.ruleDTO.orderCompleteLimitPayment = "";
      this.form.ruleDTO.orderCompleteMaxPayment = "";
      this.form.ruleDTO.lastOrderCompleteTimeType = 0;
      this.form.ruleDTO.lastOrderCompleteStartDay = "";
      this.form.ruleDTO.lastOrderCompleteEndDay = "";
      this.form.ruleDTO.lastOrderCompleteStartTime = "";
      this.form.ruleDTO.lastOrderCompleteEndTime = "";
      this.form.ruleDTO.plusObject = 0;
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    handleLimit() {
      if (
        this.form.exchangeDayTimes &&
        this.form.exchangeTimes &&
        this.form.exchangeDayTimes * 1 > this.form.exchangeTimes * 1
      ) {
        return this.$message.warning("每天配置限制次数不可大于累计次数");
      }
    },
    handleLimit1() {
      if (
        this.form.exchangeNumPerDay &&
        this.form.quantityTotal &&
        this.form.exchangeNumPerDay * 1 > this.form.quantityTotal * 1
      ) {
        return this.$message.warning("每天配置限制次数不可大于累计次数");
      }
    },
    // 查询爱奇艺/PLUS会员数据
    getPrizeMemberList() {
      const types = {
        58: 4,
        59: 3,
      };
      const activiTypes = {
        58: this.aqyList,
        59: this.jdPlusList,
      };
      return allAccount({ type: types[this.tabActive] }).then((res) => {
        if (res.data && res.data.length > 0) {
          this.prizeMemberList = res.data.map((item, index) => {
            let obj = {
              label: "",
              value: "",
              quantityBalance: 0,
            };
            obj.label = `${item.itemName}（剩余${item.quantityBalance}${item.unit}）`;
            obj.value = item.itemId;
            obj.quantityBalance = item.quantityBalance;
            return obj;
          });
        } else {
          this.prizeMemberList = activiTypes[this.tabActive].map(
            (item, index) => {
              item.label = `${item.label}（剩余0张）`;
              return item;
            }
          );
        }
        this.form.itemId = this.prizeMemberList[0].value;
        this.quantityBalance = this.prizeMemberList[0].quantityBalance;
      });
    },
    // 查询礼品卡数据
    async getList() {
      try {
        const types = {
          60: "0,1",
          61: "2",
        };
        const params = {
          current: 1,
          size: 100000,
          status: 2,
          activateTypeStr: types[this.tabActive],
        };
        const res = await getGiftCardPage(params);
        if (res.code == 1) {
          if (res.data.records && res.data.records.length > 0) {
            this.giftCardList = res.data.records.map((item) => {
              return {
                label: item.planName,
                value: item.id,
                quantityBalance: item.quantityBalance,
                endTime: item.endTime,
              };
            });
            this.quantityBalance = this.giftCardList[0].quantityBalance;
            this.giftCardEndTime = this.giftCardList[0].endTime;
          }
        }
      } catch (error) {}
    },
    handlePrizeChange(val, type) {
      let newList = [];
      if (type == 1) {
        newList = this.prizeMemberList;
      } else {
        newList = this.giftCardList;
      }
      if (newList.length > 0) {
        let obj = newList.find((item) => item.value == val);
        if (obj) {
          this.quantityBalance = obj.quantityBalance;
          if (type == 2) {
            this.giftCardEndTime = obj.endTime;
          }
        }
      }
    },
    // 刷新
    refresh() {
      if (this.activityTypes.includes(this.tabActive)) {
        this.getPrizeMemberList();
      } else {
        this.getList();
      }
    },
    // 去c充值
    toRecharge() {
      const activityTypeList = {
        58: 4,
        59: 5,
        60: 7,
        61: 7,
      };
      const routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: activityTypeList[this.tabActive] },
      });
      window.open(routeUrl.href, "_blank");
    },
    upodata() {
      this.$forceUpdate();
    },
    // 回显
    getDetail() {
      this.loading = true;
      inquireActivity(this.valueRow.id)
        .then((res) => {
          this.loading = false;
          const {
            memberLevelPointsDTOList,
            logo,
            activityName,
            startTime,
            endTime,
            quantityTotal,
            exchangeTimes,
            exchangeDayTimes,
            ruleDescription,
            exchangeNumPerDay,
            itemId,
            assetsId,
          } = res.data;
          this.form.ruleDTO = res.data.ruleDTO || {
            activityTargetType: '1',
            partner: ["-1"],
            allowLevel: "-1",
            plusObject: 0,
            crowdIds: "",
            firstOpenCardTimeType: 0,
            openCardBeforeDay: "",
            orderCompleteLimitCount: "",
            orderCompleteMaxCount: "",
            orderCompleteLimitPayment: "",
            orderCompleteMaxPayment: "",
            lastOrderCompleteTimeType: 0,
            lastOrderCompleteStartDay: "",
            lastOrderCompleteEndDay: "",
            lastOrderCompleteStartTime: "",
            lastOrderCompleteEndTime: "",
            isCheckOpenCardTime: "",
            openCardStartTime: "",
            openCardEndTime: "",
          };
          this.$set(this.form.ruleDTO, "partner", this.form.ruleDTO.allowLevel.split(","));
          this.form.ruleDTO.activityTargetType = String(this.form.ruleDTO.activityTargetType);
          this.peopleSelected = res.data.ruleDTO.crowdIds ? res.data.ruleDTO.crowdIds.split(',') : [];
          this.form.ruleDTO.condFollow = this.form.ruleDTO.condFollow ? true : false;
          this.form.ruleDTO.studentSatus = res.data.studentSatus || "";
          this.form.logo = logo;
          this.fileList = [
            {
              url: logo,
              name: this.activityData.name,
            },
          ];
          this.form.activityName =
            activityName + (this.activityData.singleCopy ? "复制" : "");
          this.form.startTime = startTime ? startTime : null;
          this.form.endTime = endTime ? endTime : null;
          this.form.exchangeTimes = exchangeTimes == -1 ? "" : exchangeTimes;
          this.form.exchangeDayTimes =
            exchangeDayTimes == -1 ? "" : exchangeDayTimes;
          this.form.quantityTotal = quantityTotal ? quantityTotal : "";
          this.form.exchangeNumPerDay = exchangeNumPerDay || "";
          this.form.ruleDescription = ruleDescription;
          this.form.itemId = itemId || "";
          this.form.assetsId = assetsId || "";
          this.isKeyActivity = res.data.isKeyActivity || 0;
          this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
          this.customerPaperwork = res.data.customerPaperwork ? JSON.parse(res.data.customerPaperwork) : { shopNameType: 0 };
          // v2.5 复制需求
          this.selectLevelList = memberLevelPointsDTOList.map((item)=>{
            item.value = item.level;
            item.label = item.name;
            return item
          }) || [];
          const checkedLevel =
            memberLevelPointsDTOList ||
            [].filter((item) => item.allow).map((item) => item.level);
          let allLevel = true;
          let isAll = true;
          this.memberLevelList.forEach((list) => {
            if (!checkedLevel.includes(list.value)) {
              allLevel = false;
            }
          });
          memberLevelPointsDTOList.forEach((item) => {
            if (item.allow) {
              if (item.point != memberLevelPointsDTOList[0].point) {
                isAll = false;
              }
            }
          });
          this.level = this.selectLevelList.map((item) => item.level);
          // 全部会员
          if (allLevel) {
            this.memberLe = true;
          } else {
            this.memberLe = false;
          }
          // 统一设置
          if (isAll) {
            this.isLevelSet = false;
            this.memberLevelPoints = memberLevelPointsDTOList[0].point;
          } else {
            this.isLevelSet = true;
          }
          if (this.activityData.singleCopy) {
            //规则
            this.form.ruleDescription = "";
            this.form.startTime = "";
            this.form.endTime = "";
            // 复制移除状态
            delete this.form.status;
          }
          this.activityTimeChange();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    init() {
      const nameTypes = {
        58: "爱奇艺会员",
        59: "京东PLUS会员",
        60: "礼品卡",
        61: "百度网盘",
      };
      const templateUrls = {
        58: "http://cdn-image.yucrm.cn/images/Preview/aqy-big.png",
        59: "http://cdn-image.yucrm.cn/images/Preview/plus-big.png",
        60: "http://cdn-image.yucrm.cn/images/Preview/giftcard-big.png",
        61: "http://cdn-image.yucrm.cn/images/Preview/bdwp-big.png",
      };
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "0",
          openMerchant: "",
          openType: 0,
          imageName: nameTypes[this.tabActive],
          templateUrl: templateUrls[this.tabActive],
          updateTime: "2021-11-12 10:19:55",
          templateUItype: 1,
        },
      ];
      if (!this.valueRow) {
        this.form.startTime = this.$getDate(30)[0];
        this.form.endTime = this.$getDate(30)[1];
        this.activityTimeChange();
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].templateUrl,
        });
      }
    },
    nextStepKai(item) {
      this.localStep = 1;
    },
    isLevel() {
      this.isLevelSet = !this.isLevelSet;
      this.memberLevelPoints = "";
      this.selectLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    async getLevel() {
      if (this.activityTypes.includes(this.tabActive)) {
        await this.getPrizeMemberList();
      } else {
        this.getList();
      }
      querymemberLevel().then((res) => {
        this.memberLevelList = res.data.map((item) => {
          let obj = {
            value: item.customerLevel,
            label: item.customerLevelName,
            point: "",
          };
          return obj;
        });
        this.selectLevelList = this.memberLevelList;
        // 默认全部选中
        this.level = res.data.map((item) => item.customerLevel);
        // 复制、跨店复制、草稿编辑
        if (this.valueRow && this.valueRow.id) {
          this.isCopy = this.activityData.singleCopy;
          this.getDetail();
        }
      });
    },
    //返回
    retrunMethod() {
      if (this.isCopy && this.localStep != 0) return (this.localStep = 0);
      if (!this.valueRow) {
        this.form.startTime = this.$getDate(30)[0];
        this.form.endTime = this.$getDate(30)[1];
        this.activityTimeChange();
      }
      this.form.activityName = "";
      this.form.exchangeTimes = "";
      this.form.exchangeDayTimes = "";
      this.form.exchangeNumPerDay = "";
      this.form.quantityTotal = "";
      this.form.ruleDescription = "";
      if (this.activityTypes.includes(this.tabActive)) {
        this.form.itemId =
          this.prizeMemberList.length > 0 ? this.prizeMemberList[0].value : "";
      } else {
        this.form.assetsId = "";
        this.quantityBalance = 0
        this.giftCardEndTime =
          this.giftCardList.length > 0 ? this.giftCardList[0].endTime : "";
      }
      this.level = [1, 2, 3, 4, 5];
      this.memberLe = true;
      this.memberLevelPoints = "";
      if (this.localStep == 0) this.$emit("returnback");
      if (this.localStep == 1) this.localStep = 0;
    },
    //活动时间驱动
    activityTimeChange(val) {
      // 校验有无时间
      if (!this.form.endTime || !this.form.startTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.form.endTime = null;
        return;
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.form.endTime).getTime() -
          new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    //选中改变
    checkListchange(val) {
      if (val) {
        this.level = this.memberLevelList.map((item) => item.value);
        this.selectLevelList = this.memberLevelList;
      } else {
        this.level = [];
        this.selectLevelList = [];
      }
    },

    checkTheChange(val) {
      this.selectLevelList = this.memberLevelList.filter((item) =>
        val.includes(item.value)
      );
      if (val.length == this.memberLevelList.length) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },
    // 上传成功
    handleSuccess(res, file, fileList) {
      this.form.logo = res.data;
      this.fileList = fileList;
    },
    beforeUpload(file) {
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      const isLimit = file.size < 1024 * 1024 * 1.5;
      if (!isJPG) {
        this.$message.error("上传图片格式必须为 JPG/PNG");
        this.fileList = [];
      }
      if (!isLimit) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.fileList = [];
      }
      return isJPG && isLimit;
    },
    handleRemove(file, fileList) {
      this.form.logo = "";
      this.fileList = [];
    },
    // 生成规则
    generativerule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "每人每天限兑换次数：",
        text4 = "活动总兑换次数限制：",
        text5 = "兑换所需等级积分：";

      if (this.form.startTime && this.form.endTime) {
        text1 = `活动时间：${this.form.startTime} 至 ${this.form.endTime}`;
      }
      //活动名称
      if (this.form.activityName) {
        text2 = `活动名称：${this.form.activityName}`;
      }
      if (this.form.exchangeDayTimes) {
        text3 += this.form.exchangeDayTimes + "次";
      } else {
        text3 += `不限`;
      }
      if (this.form.exchangeTimes) {
        text4 += this.form.exchangeTimes + "次";
      } else {
        text4 += `不限`;
      }
      this.level.sort();
      let levelStr = [];
      if (this.memberLe) {
        if (!this.isLevelSet) {
          this.selectLevelList.forEach((it, index) => {
            levelStr.push(it.label + "=" + this.memberLevelPoints + "积分");
          });
        } else {
          this.selectLevelList.forEach((it, index) => {
            levelStr.push(it.label + "=" + it.point + "积分");
          });
        }
        text5 += levelStr.join("、");
      } else {
        if (this.isLevelSet) {
          this.selectLevelList.forEach((it, index) => {
            levelStr.push(it.label + "=" + it.point + "积分");
          });
        } else {
          this.selectLevelList.forEach((item, index) => {
            levelStr.push(item.label + "=" + this.memberLevelPoints + "积分");
          });
        }
        text5 += levelStr.join("、");
      }
      let Arr1 = [text1, text2, text3, text4, text5];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "。" + "\n";
          newNum = newNum + 1;
        }
      });
      this.form.ruleDescription = newText;
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setActivity();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.setActivity();
        });
      }
    },
    //创建礼品兑换活动
    async setActivity() {
      if (!this.isDraft) {
        //活动创建限制
        if (!this.form.activityName) {
          this.$message.warning("请输入礼品名称");
          return;
        }
        const ruleDTO = this.form.ruleDTO;
        if (ruleDTO.activityTargetType == 3 && !this.peopleSelected.length) {
          this.$message.warning("请选择指定人群");
          return;
        }
        if (ruleDTO.activityTargetType == "2") {
          if (
            ruleDTO.firstOpenCardTimeType == 1 &&
            !ruleDTO.openCardBeforeDay
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
          if (
            ruleDTO.firstOpenCardTimeType == 2 &&
            (!ruleDTO.openCardStartTime || !ruleDTO.openCardEndTime)
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
          if (
            ruleDTO.lastOrderCompleteTimeType == 1 &&
            (!ruleDTO.lastOrderCompleteStartDay &&
              !ruleDTO.lastOrderCompleteEndDay)
          ) {
            this.$message.warning("请完善购物条件");
            return;
          }
          if (
            ruleDTO.lastOrderCompleteTimeType == 2 &&
            (!ruleDTO.lastOrderCompleteStartTime ||
              !ruleDTO.lastOrderCompleteEndTime)
          ) {
            this.$message.warning("请完善购物条件");
            return;
          }
        }
        if (!this.form.logo) {
          this.$message.warning("请添加礼品图片");
          return;
        }
        if (
          this.form.exchangeDayTimes &&
          this.form.exchangeTimes &&
          this.form.exchangeDayTimes * 1 > this.form.exchangeTimes * 1
        ) {
          return this.$message.warning("每天配置限制次数不可大于累计次数");
        }
        if (this.tabActive == 58 || this.tabActive == 59) {
          if (
            this.form.exchangeNumPerDay &&
            this.form.quantityTotal &&
            this.form.exchangeNumPerDay * 1 > this.form.quantityTotal * 1
          ) {
            return this.$message.warning("每天配置限制次数不可大于累计次数");
          }
        }
        if (!this.form.exchangeNumPerDay || !this.form.quantityTotal) {
          if (this.tabActive == 58 || this.tabActive == 59) {
            return this.$message.warning("请输入发放数量");
          }
        }
        if (!this.form.startTime || !this.form.endTime) {
          this.$message.warning("请输入上下架时间");
          return;
        }
        let nowTime = new Date().getTime();
        let start = new Date(this.form.startTime).valueOf();
        let end = new Date(this.form.endTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return;
        }
        if (end < start) {
          this.$message.warning("结束时间不能小于开始时间");
          return;
        }
        if (
          !this.form.quantityTotal &&
          (this.tabActive == 60 || this.tabActive == 61)
        ) {
          this.$message.warning("请输入发行总量");
          return;
        }
        if (this.level.length == 0) {
          this.$message.warning("请输入兑换所需等级");
          return;
        }
        // 兑换所需积分校验
        if (this.isLevelSet) {
          let flag = false;
          this.selectLevelList.forEach((list) => {
            if (!list.point) {
              flag = true;
            }
          });
          if (flag) return this.$message.warning("请输入兑换所需积分");
        } else {
          if (!this.memberLevelPoints) {
            this.$message.warning("请输入兑换所需积分");
            return;
          }
        }

        if (this.tabActive == 58 || this.tabActive == 59) {
          if (
            (this.form.exchangeNumPerDay &&
              this.form.exchangeNumPerDay * 1 > this.quantityBalance * 1) ||
            (this.form.quantityTotal &&
              this.form.quantityTotal * 1 > this.quantityBalance * 1)
          ) {
            return this.$message.warning(
              "每日以及累计发放数量不可大于账户余量"
            );
          }
        }

        if (this.tabActive == 60 || this.tabActive == 61) {
          if (this.form.quantityTotal * 1 > this.quantityBalance * 1) {
            return this.$message.warning("发行总量不能大于账户余量");
          }

          if (end > new Date(this.giftCardEndTime).valueOf()) {
            this.$message.warning("活动时间不可超过礼品卡有效期！");
            return;
          }
        }

        if (!this.form.ruleDescription) {
          this.$message.warning("请输入规则说明");
          return;
        }
        if(this.placementPosition.length==0) {
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }
      let obj = {
        ...this.form,
        studentSatus: this.form.ruleDTO.studentSatus,
        activityType: this.tabActive,
        memberLevelPointsDTOList: [],
        placementPosition: this.placementPosition.join(","),
        isKeyActivity: this.isKeyActivity,
        customerPaperwork: JSON.stringify(this.customerPaperwork),
      };
      obj.studentSatus = this.form.ruleDTO.studentSatus || "";
      obj.ruleDTO = this.form.ruleDTO;
      delete obj.ruleDTO.studentSatus;
      obj.ruleDTO.crowdIds = this.peopleSelected.join(",");
      delete obj.ruleDTO.studentSatus;
      if(obj.ruleDTO.activityTargetType != 2) {
        obj.ruleDTO.allowLevel = "-1";
      } else {
        obj.ruleDTO.allowLevel = obj.ruleDTO.partner.join(",");
      }
      // 处理兑换所需积分
      obj.memberLevelPointsDTOList = this.selectLevelList.map((item) => {
        const checked = this.level.includes(item.value);
        return {
          allow: checked,
          level: item.value,
          levelName: item.label,
          point: checked
            ? this.isLevelSet
              ? item.point
              : this.memberLevelPoints
            : 0,
        };
      });
      // 草稿箱
      if (this.isDraft) {
        obj.status = 5;
      }
      // 草稿箱编辑-添加活动id
      if (this.isDraftEdit) {
        obj.id = this.valueRow.id;
      }
      if (this.isCopy) {
        delete obj.id;
      }
      const res = await createPointsExchangeGift(obj);
      if (res && res.code == 1) {
        if (this.isDraft) {
          this.$emit("returnback", true);
        } else {
          this.$message.success(res.message);
          this.$router.push({
            name: "throw",
            query: {
              id: res.data.id,
              activityType: res.data.activityType,
            },
          });
        }
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  background: #ffffff;
  height: 100%;
  border-radius: 6px;
}

.firststep {
  min-height: 720px;
  box-sizing: border-box;
  padding: 0px 35px;
}
.secondstep {
  box-sizing: border-box;
  position: relative;
  padding: 0px 28px 1px 24px;
  margin-bottom: 29px;
}
.level-wrap {
  display: flex;
  /deep/.el-checkbox-group {
    margin-right: 16px;
  }
}
.mt8 {
  margin-top: 8px;
}
.tip-color {
  margin-top: 8px;
  color: red;
}

.unload-content {
  .img-uploader {
    border-radius: 3px 3px 3px 3px;
  }

  .hide-upload-btn {
    /deep/ .el-upload--picture-card {
      display: none !important;
    }
  }
}
.pd20 {
  padding: 20px 20px 16px;
}
</style>
